module.exports = __webpack_public_path__ + "static/img/ico-cancer-22.8a69f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c28/ico-cancer-22.png
// module id = a6Pu
// module chunks = 0